import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRoute from "./routes/PrivateRoutes";
import Cadastro from "./pages/Cadastro";
import Informacoes from "./pages/Informacoes";
import LayoutBase from "./layout/LayoutBase";
import Holerite from "./pages/Informacoes/Holerite";
import PLR from "./pages/Informacoes/PLR";
import Refeicao from "./pages/Refeicao";
import Almoco from "./pages/Refeicao/Almoco";
import CafeManha from "./pages/Refeicao/CafeManha";
import Engajamento from "./pages/Engajamento";
import AvaliacaoDesempenho from "./pages/AvaliacaoDesempenho";
import Avaliacoes from "./pages/AvaliacaoDesempenho/Avaliacoes";
import Adiantamento from "./pages/Informacoes/Adiantamento";
import ControlePJ from "./pages/Informacoes/Controlepj";
import Comunicado from "./pages/Comunicado";
import MenuConteudo from "./pages/MenuConteudo";
import DiagnosticoPush from "./pages/DiagnosticoPush";
import CartaoColaborador from "./pages/CartaoColaborador";
import Produtividade from "./pages/Produtividade";
import InstallButton from "./InstallButton";
import ScrollToTop from "./components/ScrollToTop";
import VLibrasWidget from "./components/VLibrasWidget/VLibrasWidget";
import { NetworkProvider } from "./context/NetworkContext";
import { MenuProvider } from "./context/MenuContext";
import { registrarPush } from "./services/push";
import api from "./services/api";
import { useContext, useEffect } from "react";
import { AuthContext } from "./context/AuthContext"; 


export default function App() {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user) return;

    // Roda no login/cold start (troca de referência de `user`) E toda vez que
    // o app volta ao primeiro plano (pedido do usuário, 2026-09-25: "toda vez
    // que entrar, abrir o app, verificar e se não tiver, inserir") - antes só
    // rodava uma vez por sessão de login. Reenviar é seguro e barato: o
    // backend faz upsert (ver PostDispositivo/srvPortal), não duplica nada.
    function tentarRegistrar() {
      registrarPush(user.codfun, user.tipfun, api).catch(err => {
        // registrarPush já trata/loga cada etapa internamente e não deveria
        // rejeitar - isto aqui é só uma rede de segurança pra nunca virar uma
        // promise rejeitada sem dono.
        console.error("[push] falha inesperada ao registrar", err);
      });
    }

    tentarRegistrar();

    function aoVoltarPrimeiroPlano() {
      if (document.visibilityState === "visible") tentarRegistrar();
    }
    document.addEventListener("visibilitychange", aoVoltarPrimeiroPlano);
    return () => document.removeEventListener("visibilitychange", aoVoltarPrimeiroPlano);
  }, [user]);

  return (
    <NetworkProvider>
      <MenuProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/home"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Home />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/cadastro"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Cadastro />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/informacoes"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Informacoes />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/informacoes/holerite"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Holerite />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/informacoes/plr"
          element={
            <PrivateRoute>
              <LayoutBase>
                <PLR />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/informacoes/vale"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Adiantamento />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/informacoes/controle"
          element={
            <PrivateRoute>
              <LayoutBase>
                <ControlePJ />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/refeicao"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Refeicao />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/refeicao/almoco"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Almoco />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/refeicao/cafe-manha"
          element={
            <PrivateRoute>
              <LayoutBase>
                <CafeManha />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/engajamento"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Engajamento />
              </LayoutBase>
            </PrivateRoute>
          }
        />
        <Route
          path="/avaliacao-desempenho"
          element={
            <PrivateRoute>
              <LayoutBase>
                <AvaliacaoDesempenho />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/avaliacao-desempenho/avaliacoes"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Avaliacoes />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/comunicado/:codcom"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Comunicado />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/menu-conteudo"
          element={
            <PrivateRoute>
              <LayoutBase>
                <MenuConteudo />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/diagnostico-push"
          element={
            <PrivateRoute>
              <LayoutBase>
                <DiagnosticoPush />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/cartao-colaborador"
          element={
            <PrivateRoute>
              <LayoutBase>
                <CartaoColaborador />
              </LayoutBase>
            </PrivateRoute>
          }
        />

        <Route
          path="/produtividade"
          element={
            <PrivateRoute>
              <LayoutBase>
                <Produtividade />
              </LayoutBase>
            </PrivateRoute>
          }
        />

      </Routes>
      </MenuProvider>

       <InstallButton />
       <VLibrasWidget />
    </NetworkProvider>
  );
}